import { Dialog, LinearProgress, Stack } from '@mui/material';
import React, { useContext } from 'react';
import UIContext from '../../context/UIContext';
import Loader from '../../Loaders/Loader';
import Loading from './Loading';

const LinearProgressLoading = () => {
  const { openLoader } = useContext(UIContext);
  return (
    <Dialog
      open={openLoader}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
      }}
    >
      <Stack
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          backgroundColor: '#ffffff00',
        }}
      >
        {/* <Loader /> */}
        <Loading />
      </Stack>
    </Dialog>
  );
};

export default LinearProgressLoading;
